import { agendaFixture } from "./fixtures/agenda";

export type AgendaPriority = "Prioritaria" | "Da seguire";
export type AgendaTaskStatus = "Da fare" | "In corso" | "Completato";
export type AgendaEventKind = "Riunione" | "Blocco lavoro";
export type AgendaEmail = { id: string; subject: string; sender: string; preview: string; time: string; priority: AgendaPriority; relatedPractice: string };
export type AgendaTask = { id: string; title: string; owner: string; status: AgendaTaskStatus; due: string; client: string; practice: string };
export type AgendaEvent = { id: string; title: string; kind: AgendaEventKind; start: string; end: string; client: string; practice: string; activity: string; participants: string[] };
export type AgendaConflict = { id: string; title: string; details: string; severity: "Da verificare"; relatedEventIds: string[] };
export type AutomationSuggestion = { id: string; type: "promemoria" | "follow-up" | "aggiornamento"; title: string; detail: string; target: "task" | "calendar" };
export type AgendaData = { emails: AgendaEmail[]; tasks: AgendaTask[]; events: AgendaEvent[]; conflicts: AgendaConflict[]; suggestions: AutomationSuggestion[] };

const wait = (ms = 260) => new Promise((resolve) => setTimeout(resolve, ms));
let tasks = [...agendaFixture.tasks];
export async function getAgenda(mode: "available" | "empty" | "error" = "available"): Promise<AgendaData> {
  await wait();
  if (mode === "error") throw new Error("Agenda demo non disponibile");
  if (mode === "empty") return { emails: [], tasks: [], events: [], conflicts: [], suggestions: [] };
  return { ...agendaFixture, tasks: tasks.map((task) => ({ ...task })) };
}
export async function updateAgendaTask(id: string, status: AgendaTaskStatus): Promise<AgendaTask | undefined> {
  await wait(180);
  tasks = tasks.map((task) => task.id === id ? { ...task, status } : task);
  return tasks.find((task) => task.id === id);
}
export async function confirmAutomation(id: string): Promise<AutomationSuggestion | undefined> { await wait(180); return agendaFixture.suggestions.find((item) => item.id === id); }
